import React from 'react';
import { Route, Routes } from 'react-router-dom'
import Blog from '../blog/Blog';
import BookmarkList from './routes/BookmarkList';
import BookmarkDetail from './routes/BookmarkDetail';
import RecipeList from './routes/RecipeList';
import RecipeDetail from './routes/RecipeDetail';
import TilList from './routes/TilList';
import TilDetail from './routes/TilDetail';
import AppList from './routes/AppList';
import ContextSwitcher from '../apps/context-switcher/ContextSwitcher';

import './Main.css';

function Main() {
  return (
    <Routes>
      <Route path="/" element={<Blog />}/>
      <Route path="/blogs" element={<Blog />}/>
      <Route path="/bookmarks" element={<BookmarkList />}/>
      <Route path="/bookmarks/:section/:bookmarkName" element={<BookmarkDetail />}/>
      <Route path="/recipes" element={<RecipeList />}/>
      <Route path="/recipes/:recipeName" element={<RecipeDetail />}/>
      <Route path="/til" element={<TilList />}/>
      <Route path="/til/:date" element={<TilDetail />}/>
      <Route path="/apps" element={<AppList />}/>
      <Route path="/apps/context-switcher" element={<ContextSwitcher />}/>
    </Routes>
  );
}

export default Main;
